import React from 'react';
import { LocationSearch } from '../../../components';

export default function PreviewPoisDestinationTab() {
  return <LocationSearch key="tab-pois-service" orderBy="tours-counter" onlyPreview={true} />;
}
